// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { GetCallsData, GetCallsResponse, GetCallsError, GetCallData, GetCallResponse, GetCallError, HangupCallData, HangupCallResponse, HangupCallError, GetCallRecordingData, GetCallRecordingError, GetCallTelemetryData, GetCallTelemetryResponse, GetCallTelemetryError, GetCapacityData, GetCapacityResponse, GetCapacityError, ListReservationsData, ListReservationsResponse, ListReservationsError, ReserveCapacityData, ReserveCapacityResponse, ReserveCapacityError, GetReservationData, GetReservationResponse, GetReservationError, ExtendReservationData, ExtendReservationResponse, ExtendReservationError, ReleaseReservationData, ReleaseReservationResponse, ReleaseReservationError, StartDemoCallData, StartDemoCallResponse, StartDemoCallError, FleetAutoscalerData, FleetAutoscalerResponse, FleetAutoscalerError, AssembleCellData, AssembleCellResponse, AssembleCellError, DeleteCellData, DeleteCellResponse, DeleteCellError, GetFleetCellData, GetFleetCellResponse, GetFleetCellError, AddUnitToCellData, AddUnitToCellResponse, AddUnitToCellError, FleetOverviewData, FleetOverviewResponse, FleetOverviewError, ListFleetProvidersData, ListFleetProvidersResponse, ListFleetProvidersError, CreateFleetProviderData, CreateFleetProviderResponse, CreateFleetProviderError, SetProviderEtalonData, SetProviderEtalonResponse, SetProviderEtalonError, ConfirmPauseSemanticsData, ConfirmPauseSemanticsResponse, ConfirmPauseSemanticsError, ScanFleetProviderData, ScanFleetProviderResponse, ScanFleetProviderError, ScaleDownData, ScaleDownResponse, ScaleDownError, ScaleUpData, ScaleUpResponse, ScaleUpError, ListFleetSignalsData, ListFleetSignalsResponse, ListFleetSignalsError, ClearFleetSignalData, ClearFleetSignalResponse, ClearFleetSignalError, ListFleetUnitsData, ListFleetUnitsResponse, ListFleetUnitsError, ProvisionUnitData, ProvisionUnitResponse, ProvisionUnitError, GetFleetUnitData, GetFleetUnitResponse, GetFleetUnitError, DeleteUnitData, DeleteUnitResponse, DeleteUnitError, PauseUnitData, PauseUnitResponse, PauseUnitError, ResumeUnitData, ResumeUnitResponse, ResumeUnitError, FleetWgPeersData, FleetWgPeersResponse, FleetWgPeersError, ListScenariosData, ListScenariosResponse, ListScenariosError, CreateScenarioData, CreateScenarioResponse, CreateScenarioError, DeleteScenarioData, DeleteScenarioResponse, DeleteScenarioError, GetScenarioData, GetScenarioResponse, GetScenarioError, UpdateScenarioData, UpdateScenarioResponse, UpdateScenarioError, ListSipAccountsData, ListSipAccountsResponse, ListSipAccountsError, RegisterSipAccountData, RegisterSipAccountResponse, RegisterSipAccountError, DeleteSipAccountData, DeleteSipAccountResponse, DeleteSipAccountError, GetSipAccountData, GetSipAccountResponse, GetSipAccountError, UpdateSipAccountData, UpdateSipAccountResponse, UpdateSipAccountError, DisableSipAccountData, DisableSipAccountResponse, DisableSipAccountError, VerifySipAccountData, VerifySipAccountResponse, VerifySipAccountError, ListLineLeasesData, ListLineLeasesResponse, ListLineLeasesError, ReleaseLineLeaseData, ReleaseLineLeaseResponse, ReleaseLineLeaseError, ListTelephonyPoolsData, ListTelephonyPoolsResponse, ListTelephonyPoolsError, CreateTelephonyPoolData, CreateTelephonyPoolResponse, CreateTelephonyPoolError, GetTelephonyPoolData, GetTelephonyPoolResponse, GetTelephonyPoolError, DisableTelephonyPoolData, DisableTelephonyPoolResponse, DisableTelephonyPoolError, EnableTelephonyPoolData, EnableTelephonyPoolResponse, EnableTelephonyPoolError, ListTelephonyProfilesData, ListTelephonyProfilesResponse, ListTelephonyProfilesError, CreateTelephonyProfileData, CreateTelephonyProfileResponse, CreateTelephonyProfileError, RetireTelephonyProfileData, RetireTelephonyProfileResponse, RetireTelephonyProfileError, GetTelephonyProfileData, GetTelephonyProfileResponse, GetTelephonyProfileError, UpdateTelephonyProfileData, UpdateTelephonyProfileResponse, UpdateTelephonyProfileError, StartTestCallData, StartTestCallResponse, StartTestCallError, UnitClaimData, UnitClaimResponse, UnitClaimError, UnitConfigData, UnitConfigResponse, UnitConfigError, UnitHeartbeatData, UnitHeartbeatResponse, UnitHeartbeatError, GetUsageData, GetUsageResponse, GetUsageError, ListVoicesData, ListVoicesResponse, ListVoicesError, CreateVoiceData, CreateVoiceResponse, CreateVoiceError, DeleteVoiceData, DeleteVoiceResponse, DeleteVoiceError, GetVoiceData, GetVoiceResponse, GetVoiceError, GetVoiceClipData, GetVoiceClipError, GetHealthData, GetHealthResponse, GetHealthError, GetReadyData, GetReadyResponse, GetReadyError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Живая доска + завершённые звонки
 */
export const getCalls = <ThrowOnError extends boolean = false>(options?: Options<GetCallsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCallsResponse, GetCallsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/calls',
        ...options
    });
};

/**
 * Детали звонка (полный отчёт)
 */
export const getCall = <ThrowOnError extends boolean = false>(options: Options<GetCallData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCallResponse, GetCallError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/calls/{call_id}',
        ...options
    });
};

/**
 * Принудительно завершить звонок (call.cmd.hangup)
 */
export const hangupCall = <ThrowOnError extends boolean = false>(options: Options<HangupCallData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<HangupCallResponse, HangupCallError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/calls/{call_id}/hangup',
        ...options
    });
};

/**
 * Запись разговора потоком (audio/wav) — бакет наружу не торчит
 */
export const getCallRecording = <ThrowOnError extends boolean = false>(options: Options<GetCallRecordingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, GetCallRecordingError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/calls/{call_id}/recording',
        ...options
    });
};

/**
 * Разбор звонка ход за ходом (тела кусков callv1)
 */
export const getCallTelemetry = <ThrowOnError extends boolean = false>(options: Options<GetCallTelemetryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCallTelemetryResponse, GetCallTelemetryError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/calls/{call_id}/telemetry',
        ...options
    });
};

/**
 * Картина ёмкости по пулам: линии, слоты, заявки, очередь (admin|api)
 */
export const getCapacity = <ThrowOnError extends boolean = false>(options?: Options<GetCapacityData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCapacityResponse, GetCapacityError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/capacity',
        ...options
    });
};

/**
 * Заявки на ёмкость (admin|api)
 */
export const listReservations = <ThrowOnError extends boolean = false>(options?: Options<ListReservationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListReservationsResponse, ListReservationsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/capacity/reservations',
        ...options
    });
};

/**
 * Завести заявку на ёмкость (201); повтор с тем же id и телом — 200 с существующей, с другим телом — 409 FLEET_RESERVATION_MISMATCH (admin|api)
 */
export const reserveCapacity = <ThrowOnError extends boolean = false>(options: Options<ReserveCapacityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReserveCapacityResponse, ReserveCapacityError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/capacity/reservations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Заявка: слоты, ячейки, ожидание линий, просрочка (admin|api)
 */
export const getReservation = <ThrowOnError extends boolean = false>(options: Options<GetReservationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetReservationResponse, GetReservationError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/capacity/reservations/{id}',
        ...options
    });
};

/**
 * Продлить окно заявки вперёд; размер заявки не меняется (admin|api)
 */
export const extendReservation = <ThrowOnError extends boolean = false>(options: Options<ExtendReservationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ExtendReservationResponse, ExtendReservationError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/capacity/reservations/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Отозвать заявку: единственный путь, которым она заканчивается (admin|api)
 */
export const releaseReservation = <ThrowOnError extends boolean = false>(options: Options<ReleaseReservationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReleaseReservationResponse, ReleaseReservationError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/capacity/reservations/{id}/release',
        ...options
    });
};

/**
 * WebRTC-демо-звонок: явно выбранная ячейка или свободный операторский юнит (admin)
 */
export const startDemoCall = <ThrowOnError extends boolean = false>(options: Options<StartDemoCallData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<StartDemoCallResponse, StartDemoCallError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/demo-call',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Последний прогон автоскейлера: что решено по каждой заявке и почему (admin)
 */
export const fleetAutoscaler = <ThrowOnError extends boolean = false>(options?: Options<FleetAutoscalerData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<FleetAutoscalerResponse, FleetAutoscalerError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/autoscaler',
        ...options
    });
};

/**
 * Собрать ячейку 1×C + N×L и арендовать линии (admin)
 */
export const assembleCell = <ThrowOnError extends boolean = false>(options: Options<AssembleCellData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssembleCellResponse, AssembleCellError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/cells',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Стереть строку демонтированной ячейки и её удалённые юниты (admin)
 */
export const deleteCell = <ThrowOnError extends boolean = false>(options: Options<DeleteCellData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCellResponse, DeleteCellError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/cells/{id}',
        ...options
    });
};

/**
 * Ячейка: карточка для дриллдауна; демонтированная — 404 (admin)
 */
export const getFleetCell = <ThrowOnError extends boolean = false>(options: Options<GetFleetCellData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFleetCellResponse, GetFleetCellError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/cells/{id}',
        ...options
    });
};

/**
 * Добавить L-юнит в живую ячейку: ёмкость растёт, статус не меняется (admin)
 */
export const addUnitToCell = <ThrowOnError extends boolean = false>(options: Options<AddUnitToCellData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddUnitToCellResponse, AddUnitToCellError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/cells/{id}/units',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Доска флота; терминальные юниты/ячейки — только с include=all (admin)
 */
export const fleetOverview = <ThrowOnError extends boolean = false>(options?: Options<FleetOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<FleetOverviewResponse, FleetOverviewError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/overview',
        ...options
    });
};

/**
 * GPU-провайдеры (admin)
 */
export const listFleetProviders = <ThrowOnError extends boolean = false>(options?: Options<ListFleetProvidersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFleetProvidersResponse, ListFleetProvidersError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/providers',
        ...options
    });
};

/**
 * Завести аккаунт GPU-провайдера (admin)
 */
export const createFleetProvider = <ThrowOnError extends boolean = false>(options: Options<CreateFleetProviderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateFleetProviderResponse, CreateFleetProviderError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/providers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Назначить сервер аккаунта эталоном клона для класса (admin)
 */
export const setProviderEtalon = <ThrowOnError extends boolean = false>(options: Options<SetProviderEtalonData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SetProviderEtalonResponse, SetProviderEtalonError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/providers/{id}/etalon',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Зафиксировать семантику паузы (admin)
 */
export const confirmPauseSemantics = <ThrowOnError extends boolean = false>(options: Options<ConfirmPauseSemanticsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfirmPauseSemanticsResponse, ConfirmPauseSemanticsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/providers/{id}/pause-semantics',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Скан аккаунта провайдера: живой список серверов + привязка к юнитам (admin)
 */
export const scanFleetProvider = <ThrowOnError extends boolean = false>(options: Options<ScanFleetProviderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ScanFleetProviderResponse, ScanFleetProviderError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/providers/{id}/servers',
        ...options
    });
};

/**
 * Слить ячейки (admin)
 */
export const scaleDown = <ThrowOnError extends boolean = false>(options: Options<ScaleDownData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ScaleDownResponse, ScaleDownError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/scale-down',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Поднять ёмкость под заявку — ручной прогрев (admin)
 */
export const scaleUp = <ThrowOnError extends boolean = false>(options: Options<ScaleUpData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ScaleUpResponse, ScaleUpError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/scale-up',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Сигналы флота: что требует внимания и с какого момента (admin)
 */
export const listFleetSignals = <ThrowOnError extends boolean = false>(options?: Options<ListFleetSignalsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFleetSignalsResponse, ListFleetSignalsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/signals',
        ...options
    });
};

/**
 * Снять одноразовый сигнал; выводимый снимается сам (admin)
 */
export const clearFleetSignal = <ThrowOnError extends boolean = false>(options: Options<ClearFleetSignalData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ClearFleetSignalResponse, ClearFleetSignalError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/signals/{id}/clear',
        ...options
    });
};

/**
 * Юниты флота; удалённые — только с include=all (admin)
 */
export const listFleetUnits = <ThrowOnError extends boolean = false>(options?: Options<ListFleetUnitsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFleetUnitsResponse, ListFleetUnitsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/units',
        ...options
    });
};

/**
 * Создать сервер у провайдера; токены юнита отдаются один раз (admin)
 */
export const provisionUnit = <ThrowOnError extends boolean = false>(options: Options<ProvisionUnitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProvisionUnitResponse, ProvisionUnitError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/units',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Юнит: карточка для дриллдауна; удалённый — 404 (admin)
 */
export const getFleetUnit = <ThrowOnError extends boolean = false>(options: Options<GetFleetUnitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFleetUnitResponse, GetFleetUnitError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/units/{id}',
        ...options
    });
};

/**
 * Удалить юнит у провайдера (admin)
 */
export const deleteUnit = <ThrowOnError extends boolean = false>(options: Options<DeleteUnitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteUnitResponse, DeleteUnitError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/units/{id}/delete',
        ...options
    });
};

/**
 * Пауза юнита (admin)
 */
export const pauseUnit = <ThrowOnError extends boolean = false>(options: Options<PauseUnitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PauseUnitResponse, PauseUnitError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/units/{id}/pause',
        ...options
    });
};

/**
 * Возврат юнита с паузы (admin)
 */
export const resumeUnit = <ThrowOnError extends boolean = false>(options: Options<ResumeUnitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResumeUnitResponse, ResumeUnitError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/units/{id}/resume',
        ...options
    });
};

/**
 * Пиры wg-hub'а: юниты с выданной identity — по ним сайдкар cp программирует контур (admin)
 */
export const fleetWgPeers = <ThrowOnError extends boolean = false>(options?: Options<FleetWgPeersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<FleetWgPeersResponse, FleetWgPeersError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/fleet/wg-peers',
        ...options
    });
};

/**
 * Каталог сценариев разговора
 */
export const listScenarios = <ThrowOnError extends boolean = false>(options?: Options<ListScenariosData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListScenariosResponse, ListScenariosError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/scenarios',
        ...options
    });
};

/**
 * Завести сценарий разговора (admin — любой, api — с owner_account_id)
 */
export const createScenario = <ThrowOnError extends boolean = false>(options: Options<CreateScenarioData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateScenarioResponse, CreateScenarioError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/scenarios',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Удалить сценарий (admin — любой, api — только клиентский)
 */
export const deleteScenario = <ThrowOnError extends boolean = false>(options: Options<DeleteScenarioData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteScenarioResponse, DeleteScenarioError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/scenarios/{id}',
        ...options
    });
};

/**
 * Сценарий по id
 */
export const getScenario = <ThrowOnError extends boolean = false>(options: Options<GetScenarioData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetScenarioResponse, GetScenarioError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/scenarios/{id}',
        ...options
    });
};

/**
 * Переписать сценарий целиком, ревизия +1; revision в теле сверяется с прочитанной, несовпадение → 409 (admin — любой, api — только клиентский)
 */
export const updateScenario = <ThrowOnError extends boolean = false>(options: Options<UpdateScenarioData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateScenarioResponse, UpdateScenarioError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/scenarios/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Учётки; ?pool= — учётки пула
 */
export const listSipAccounts = <ThrowOnError extends boolean = false>(options?: Options<ListSipAccountsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListSipAccountsResponse, ListSipAccountsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/accounts',
        ...options
    });
};

/**
 * Завести учётку (платформенную или BYOC) и запустить верификацию
 */
export const registerSipAccount = <ThrowOnError extends boolean = false>(options: Options<RegisterSipAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RegisterSipAccountResponse, RegisterSipAccountError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/accounts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Удалить учётку; платформенная — только admin
 */
export const deleteSipAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteSipAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteSipAccountResponse, DeleteSipAccountError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/accounts/{id}',
        ...options
    });
};

/**
 * Учётка
 */
export const getSipAccount = <ThrowOnError extends boolean = false>(options: Options<GetSipAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSipAccountResponse, GetSipAccountError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/accounts/{id}',
        ...options
    });
};

/**
 * Правка учётки: пул, ёмкость, регистратор, пароль; платформенная — только admin
 */
export const updateSipAccount = <ThrowOnError extends boolean = false>(options: Options<UpdateSipAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateSipAccountResponse, UpdateSipAccountError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/accounts/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Вывести учётку из эксплуатации; платформенная — только admin
 */
export const disableSipAccount = <ThrowOnError extends boolean = false>(options: Options<DisableSipAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DisableSipAccountResponse, DisableSipAccountError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/accounts/{id}/disable',
        ...options
    });
};

/**
 * Проверить учётку; платформенная — только admin
 */
export const verifySipAccount = <ThrowOnError extends boolean = false>(options: Options<VerifySipAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VerifySipAccountResponse, VerifySipAccountError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/accounts/{id}/verify',
        ...options
    });
};

/**
 * Аренды линий; ?unit= — аренды юнита (admin)
 */
export const listLineLeases = <ThrowOnError extends boolean = false>(options?: Options<ListLineLeasesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListLineLeasesResponse, ListLineLeasesError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/leases',
        ...options
    });
};

/**
 * Слить/освободить аренду (admin)
 */
export const releaseLineLease = <ThrowOnError extends boolean = false>(options: Options<ReleaseLineLeaseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReleaseLineLeaseResponse, ReleaseLineLeaseError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/leases/{id}/release',
        ...options
    });
};

/**
 * Пулы
 */
export const listTelephonyPools = <ThrowOnError extends boolean = false>(options?: Options<ListTelephonyPoolsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTelephonyPoolsResponse, ListTelephonyPoolsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/pools',
        ...options
    });
};

/**
 * Завести пул: client — обе поверхности, platform — только admin
 */
export const createTelephonyPool = <ThrowOnError extends boolean = false>(options: Options<CreateTelephonyPoolData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTelephonyPoolResponse, CreateTelephonyPoolError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/pools',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Пул
 */
export const getTelephonyPool = <ThrowOnError extends boolean = false>(options: Options<GetTelephonyPoolData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTelephonyPoolResponse, GetTelephonyPoolError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/pools/{id}',
        ...options
    });
};

/**
 * Вывести пул из роутинга и дренировать аренды; при незакрытых заявках — 409 TELEPHONY_POOL_BUSY, ?force=true отзывает их; платформенный — только admin
 */
export const disableTelephonyPool = <ThrowOnError extends boolean = false>(options: Options<DisableTelephonyPoolData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DisableTelephonyPoolResponse, DisableTelephonyPoolError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/pools/{id}/disable',
        ...options
    });
};

/**
 * Вернуть пул в роутинг; платформенный — только admin
 */
export const enableTelephonyPool = <ThrowOnError extends boolean = false>(options: Options<EnableTelephonyPoolData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EnableTelephonyPoolResponse, EnableTelephonyPoolError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/pools/{id}/enable',
        ...options
    });
};

/**
 * Каталог профилей операторов
 */
export const listTelephonyProfiles = <ThrowOnError extends boolean = false>(options?: Options<ListTelephonyProfilesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTelephonyProfilesResponse, ListTelephonyProfilesError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/profiles',
        ...options
    });
};

/**
 * Завести профиль оператора (admin)
 */
export const createTelephonyProfile = <ThrowOnError extends boolean = false>(options: Options<CreateTelephonyProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTelephonyProfileResponse, CreateTelephonyProfileError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/profiles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Вывести профиль из каталога (admin)
 */
export const retireTelephonyProfile = <ThrowOnError extends boolean = false>(options: Options<RetireTelephonyProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RetireTelephonyProfileResponse, RetireTelephonyProfileError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/profiles/{id}',
        ...options
    });
};

/**
 * Профиль оператора
 */
export const getTelephonyProfile = <ThrowOnError extends boolean = false>(options: Options<GetTelephonyProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTelephonyProfileResponse, GetTelephonyProfileError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/profiles/{id}',
        ...options
    });
};

/**
 * Обновить параметры подключения (admin)
 */
export const updateTelephonyProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateTelephonyProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateTelephonyProfileResponse, UpdateTelephonyProfileError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/telephony/profiles/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Тест-звонок по SIP: задание сценария в очередь пула call.spec.<pool> (admin)
 */
export const startTestCall = <ThrowOnError extends boolean = false>(options: Options<StartTestCallData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<StartTestCallResponse, StartTestCallError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/test-call',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Claim клона: identity юнита по bootstrap-токену
 */
export const unitClaim = <ThrowOnError extends boolean = false>(options: Options<UnitClaimData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnitClaimResponse, UnitClaimError, ThrowOnError>({
        url: '/api/units/claim',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Конфигурация юнита (X-Unit-Token)
 */
export const unitConfig = <ThrowOnError extends boolean = false>(options: Options<UnitConfigData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UnitConfigResponse, UnitConfigError, ThrowOnError>({
        url: '/api/units/{unit_id}/config',
        ...options
    });
};

/**
 * Heartbeat юнита (X-Unit-Token)
 */
export const unitHeartbeat = <ThrowOnError extends boolean = false>(options: Options<UnitHeartbeatData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnitHeartbeatResponse, UnitHeartbeatError, ThrowOnError>({
        url: '/api/units/{unit_id}/heartbeat',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Минуты и звонки по аккаунтам за период (биллинг-качество)
 */
export const getUsage = <ThrowOnError extends boolean = false>(options?: Options<GetUsageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUsageResponse, GetUsageError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/usage',
        ...options
    });
};

/**
 * Каталог голосов
 */
export const listVoices = <ThrowOnError extends boolean = false>(options?: Options<ListVoicesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListVoicesResponse, ListVoicesError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/voices',
        ...options
    });
};

/**
 * Завести голос: аудио любого формата в теле; транскрибация на свободном C-юните + LLM-нормализация (admin — любой, api — с owner_account_id)
 */
export const createVoice = <ThrowOnError extends boolean = false>(options: Options<CreateVoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateVoiceResponse, CreateVoiceError, ThrowOnError>({
        bodySerializer: null,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/voices',
        ...options,
        headers: {
            'Content-Type': 'application/octet-stream',
            ...options?.headers
        }
    });
};

/**
 * Удалить голос вместе с ref-клипом (admin — любой, api — только клиентский)
 */
export const deleteVoice = <ThrowOnError extends boolean = false>(options: Options<DeleteVoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteVoiceResponse, DeleteVoiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/voices/{id}',
        ...options
    });
};

/**
 * Голос по id
 */
export const getVoice = <ThrowOnError extends boolean = false>(options: Options<GetVoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVoiceResponse, GetVoiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/voices/{id}',
        ...options
    });
};

/**
 * Ref-клип голоса потоком (audio/wav) — бакет наружу не торчит
 */
export const getVoiceClip = <ThrowOnError extends boolean = false>(options: Options<GetVoiceClipData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, GetVoiceClipError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/voices/{id}/clip',
        ...options
    });
};

/**
 * Health check
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetHealthResponse, GetHealthError, ThrowOnError>({
        url: '/health',
        ...options
    });
};

/**
 * Readiness check
 */
export const getReady = <ThrowOnError extends boolean = false>(options?: Options<GetReadyData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetReadyResponse, GetReadyError, ThrowOnError>({
        url: '/ready',
        ...options
    });
};